<div class="lokos-radio">
    <mat-radio-button
        [value]="value"
        [checked]="selected"
        (change)="onChange.emit($event)"
        [disabled]="disabled"
        [labelPosition]="labelPosition"
        [required]="required"
        [formControl]="control"
    >
        @if (label) {
            <mat-label>
                {{ label | translate }}
                <span class="required">{{ required ? '*' : '' }}</span>
            </mat-label>
        }
    </mat-radio-button>
    @if (control.invalid && (control.dirty || control.touched)) {
        <mat-error>{{ getErrorMessage() | translate }}</mat-error>
    }
</div>
